import { ControlElement, JsonSchema } from '@jsonforms/core'
import { materialRenderers } from '@jsonforms/material-renderers'

import {
  CheckboxControl,
  checkboxControlTester
} from './CustomControls/CheckboxControl'

import DatePickerControl, {
  datePickerControlTester
} from './CustomControls/DatePickerControl'
import { EnablerControl, enablerTester } from './CustomControls/EnablerControl'
import { InputControl, inputControlTester } from './CustomControls/InputControl'
import NumberControl, {
  numberControlTester
} from './CustomControls/NumberControl'
import {
  PhoneNumberControl,
  phoneNumberControlTester
} from './CustomControls/PhoneControl'
import radioControlTester from './CustomControls/radioControlTester'
import RadioHocControl from './CustomControls/RadioHocControl'

import SelectControl, {
  selectControlTester
} from './CustomControls/SelectControl'
import { SSNControl, ssnControlTester } from './CustomControls/SSNControl'
import { ZipControl, zipControlTester } from './CustomControls/ZipControl'
import ArrayField, { arrayFieldTester } from './Layouts/ArrayFieldLayout'
import ArrayLayout, { arrayLayoutTester } from './Layouts/ArrayLayout'
import {
  checkboxGroupLayout,
  checkboxGroupLayoutRendererTester
} from './Layouts/CheckboxGroupLayout'
import {
  customObjectRenderer,
  objectLayoutRendererTester
} from './Layouts/ObjectLayout'
import {
  CurrencyControl,
  currencyControlTester
} from './CustomControls/CurrencyControl'

export const QUESIONNAIRE_INTRODUCTION_TEXT =
  "We'll walk you step by step through bankruptcy related information about your income, property, debts and expenses.\n\n Then, easily and securely submit your completed information directly to your attorney."

export const QUESTIONNAIRE_TERMS_AND_CONDITION_TEXT =
  'I understand that some or all of the information provided herein may be used by my attorney to prepare my case and that all information I am required to provide during my bankruptcy case must be complete, accurate, and truthful. If I have any questions or issues, I can contact my attorney directly.'

export const QUESTIONNAIRE_JOINT_CASE_NOTIFICATION =
  'You are filing with your spouse. Please make sure that only one person edits the questionnaire at a time so that your information is accurate.'

export const QUESTIONNAIRE_SUBMIT_TO_ATTORNEY_DESCRIPTION =
  'Once you have reviewed your information, please affirm that you understand that some or all of the information provided herein may be used by your attorney to prepare your case and that all information you are required to provide during my bankruptcy case must be complete, accurate, and truthful. Once you submit the questionnaire, you cannot change your information unless your attorney sends the questionnaire back for edits.'

export const QUESTIONNAIRE_PERSONAL_INFO_DESCRIPTION =
  'In the Personal Information section, you will be guided through questions about your basic information, such as name (current and previous), address (current and previous), contact information, spouse (current and previous) and dependents.'

export type UISchemaWithToolTip = ControlElement & { toolTipText: string }
export type UISchemaWithPlaceHolder = ControlElement & {
  placeHolderText: string
}

export type CustomUISchema =
  | UISchemaWithToolTip
  | UISchemaWithPlaceHolder
  | (UISchemaWithToolTip & UISchemaWithPlaceHolder)

export type SchemaWithPrimaryQuestion = JsonSchema & {
  primaryQuestionField: boolean
}

export enum QUESTION_TYPE {
  SINGLE = 'SINGLE',
  SINGLE_NESTED = 'SINGLE_NESTED',
  GROUP_SINGLE = 'GROUP_SINGLE',
  GROUP_NESTED = 'GROUP_NESTED'
}

export enum OperationType {
  Back = 'BACK',
  BackAndSave = 'BACK_AND_SAVE',
  Continue = 'CONTINUE',
  Empty = '',
  Load = 'LOAD',
  Next = 'NEXT',
  Save = 'SAVE',
  SaveAndFinish = 'SAVE_AND_FINISH'
}

export interface UnitForm {
  // eslint-disable-next-line
  Schema: any | null
  // eslint-disable-next-line
  UISchema: any | null
  // eslint-disable-next-line
  Data: any | null
  QuestionCompleteFlag: boolean | false
}

export interface Question {
  QuestionId: number
  QuestionSectionId: number
  QuestionGroupId: number
  QuestionType: {
    Name: string
    Value: string
  }
  Name: string
  Value: string
  Description: string
  QuestionSummary: string
  Order: number
  IsActive: boolean
  CanBeDisabled: boolean
  IsDisabled: boolean
  IsConditionallyEnabled: boolean
  FormsAndSchedule: string
  UnitForm: UnitForm
  SubQuestions: {
    [key: string]: unknown
  }
}

export interface Group {
  QuestionGroupId: number
  QuestionSectionId: number
  ParentQuestionGroupId: number | null
  Name: string
  Value: string
  Description: string
  Order: number
  IsActive: boolean
  CanBeDisabled: boolean
  IsDisabled: boolean
  GroupSummary: string
  Questions: Question[]
}

export const formRenderers = [
  ...materialRenderers,
  //register custom renderers
  { tester: arrayLayoutTester, renderer: ArrayLayout },

  { tester: radioControlTester, renderer: RadioHocControl },
  {
    tester: checkboxControlTester,
    renderer: CheckboxControl
  },
  { tester: zipControlTester, renderer: ZipControl },
  { tester: ssnControlTester, renderer: SSNControl },

  { tester: selectControlTester, renderer: SelectControl },

  {
    tester: numberControlTester,
    renderer: NumberControl
  },
  {
    tester: datePickerControlTester,
    renderer: DatePickerControl
  },
  {
    tester: objectLayoutRendererTester,
    renderer: customObjectRenderer
  },
  { tester: inputControlTester, renderer: InputControl },
  {
    tester: arrayFieldTester,
    renderer: ArrayField
  },
  {
    tester: enablerTester,
    renderer: EnablerControl
  },
  {
    tester: currencyControlTester,
    renderer: CurrencyControl
  },
  {
    tester: arrayFieldTester,
    renderer: ArrayField
  },
  {
    tester: checkboxGroupLayoutRendererTester,
    renderer: checkboxGroupLayout
  },
  {
    tester: phoneNumberControlTester,
    renderer: PhoneNumberControl
  }
]
